import { createNamedWrapperReducer, isActionRelated } from '@core/utils/state';
import { IEntitiesState } from '../shared/entities/entities-state';
import { IBillingState, initialBillingState } from './billing-state';
import {
    BILLING_ESTIMATE_FETCH,
    BILLING_ESTIMATE_FETCH_ABORT,
    BILLING_ESTIMATE_FETCH_ERROR,
    BILLING_ESTIMATE_SET,
    BILLING_FETCH,
    BILLING_FETCH_ABORT,
    BILLING_FETCH_ERROR,
    BILLING_INVOICES_FETCH,
    BILLING_INVOICES_FETCH_ABORT,
    BILLING_INVOICES_FETCH_ERROR,
    BILLING_INVOICE_FETCH_ABORT,
    BILLING_INVOICE_FETCH_ERROR,
    BILLING_KEY_FETCH,
    BILLING_KEY_SET,
    BILLING_SET,
    BILLING_USAGE_REPORT_FETCH,
    BILLING_USAGE_REPORT_FETCH_ABORT,
    BILLING_USAGE_REPORT_FETCH_ERROR,
    BILLING_USAGE_REPORT_SET,
    BILLING_USERS_FETCH,
    BILLING_USERS_FETCH_MORE
} from '../action-types';
import { GROUP_BILLING_INVOICE, GROUP_BILLING_USER } from '../state-groups';
import { reducer as listReducer } from '../shared/list/reducer';
import { BILLING_INVOICE_ENTITY } from '../entity-types';

export function reducer(
    state: IBillingState = initialBillingState(),
    action: any,
    entitySlice: IEntitiesState
): IBillingState {
    switch (action.type) {
        case BILLING_FETCH:
            return {
                ...state,
                isBillingFetching: true,
            };

        case BILLING_FETCH_ERROR:
        case BILLING_FETCH_ABORT:
            return {
                ...state,
                isBillingFetching: false,
            };

        case BILLING_SET:
            return {
                ...state,
                isBillingFetching: false,
                billing: action.payload,
            };

        case BILLING_KEY_FETCH:
            return {
                ...state,
                isKeyFetching: true,
            };

        case BILLING_KEY_SET:
            return {
                ...state,
                isKeyFetching: false,
                key: action.payload,
            };

        case BILLING_ESTIMATE_FETCH:
            return {
                ...state,
                isEstimateFetching: true,
            };

        case BILLING_ESTIMATE_FETCH_ERROR:
        case BILLING_ESTIMATE_FETCH_ABORT:
            return {
                ...state,
                isEstimateFetching: false,
            };

        case BILLING_ESTIMATE_SET:
            return {
                ...state,
                isEstimateFetching: false,
                estimate: action.payload,
            };

        case BILLING_INVOICES_FETCH:
            return {
                ...state,
                invoices: { ...state.invoices, isFetching: true },
            };

        case BILLING_INVOICE_FETCH_ERROR:
        case BILLING_INVOICE_FETCH_ABORT:
        case BILLING_INVOICES_FETCH_ERROR:
        case BILLING_INVOICES_FETCH_ABORT:
            return {
                ...state,
                invoices: { ...state.invoices, isFetching: false },
            };

        case BILLING_USERS_FETCH:
            return {
                ...state,
                users: { ...state.users, isFetching: true },
            };

        case BILLING_USERS_FETCH_MORE:
            return {
                ...state,
                users: { ...state.users, isFetchingMore: true },
            };

        case BILLING_USAGE_REPORT_FETCH:
            return {
                ...state,
                isUsageReportFetching: true,
            };

        case BILLING_USAGE_REPORT_FETCH_ERROR:
        case BILLING_USAGE_REPORT_FETCH_ABORT:
            return {
                ...state,
                isEstimateFetching: false,
            };

        case BILLING_USAGE_REPORT_SET:
            return {
                ...state,
                report: action.payload,
            };

        default:
            let nextState: IBillingState = state;

            

            if (
                isActionRelated(action, [
                    GROUP_BILLING_INVOICE,
                    GROUP_BILLING_USER,
                ])
            ) {
                nextState = {
                    ...state,
                    invoices: createNamedWrapperReducer(
                        listReducer,
                        GROUP_BILLING_INVOICE
                    )(state.invoices, action, entitySlice.entities),
                    users: createNamedWrapperReducer(
                        listReducer,
                        GROUP_BILLING_USER
                    )(state.users, action, entitySlice.entities),
                };
            }

            return nextState;
    }
}